// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"501":"bc98253f","4316":"ad2866b8"}[chunkId] || chunkId) + "." + {"501":"61231d388644c421","2378":"c43e6b164b10cc22","2931":"b7a014d240f3dca8","3877":"044a08e634b9f34c","3917":"f638977fc7d119a3","4316":"890f6f4190c9fdfb"}[chunkId] + ".js";
};